
export default {
  transactionFields: state => state.transactionFields,
  transactionFieldsCurrentPage: state => state.transactionFieldsCurrentPage,
  transactionFieldsLastPage: state => state.transactionFieldsLastPage,
  reviewFlows: state => state.reviewFlows,
  currentReviewFlow: state => state.currentReviewFlow,
  reviewFlowsCurrentPage: state => state.reviewFlowsCurrentPage,
  reviewFlowsLastPage: state => state.reviewFlowsLastPage,
  getReviewFlow: (state) => (id) => state.reviewFlows.find(el => el.id === id),
  isCallingTransactionFields: state => state.isCallingTransactionFields,
  isCallingReviewFlows: state => state.isCallingReviewFlows
}
